import(/* webpackMode: "eager" */ "/home/runner/work/snapcards/snapcards/node_modules/next/dist/client/components/builtin/global-error.js");
